import React from 'react';

export const TsuIntensityModal = {
  title: 'Tsunami Intensity',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>-5 to 10</b>
      </div>
      <br />
      <p>Tsunami intensity is defined by Soloviev and Go (1974) as</p>
      <p>
        I = log
        <sub>2</sub>
        (2
        <sup>1/2</sup>
        {' '}
        * h)
      </p>
      {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
      <p>{'where "h" is the average runup height of the wave.\n'}</p>
    </div>
  ),
};
